import toastr from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useCookies } from 'react-cookie';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { LoginResponse } from 'types/User';

type MutationVariables = {
  email: string;
  password: string;
};

const Login = ({ email, password }: MutationVariables) => {
  return fetchWrapper<LoginResponse>({
    url: `User/Login?usernameOrEmail=${email}&password=${password}`,
    method: 'GET',
  });
};

export function useLogin() {
  const cookie = useCookies();
  const setCookie = cookie[1];

  return useMutation('user Login', Login, {
    onSuccess: (data) => {
      if (data.isSuccess) {
        setCookie('userToken', data.data.token, { path: '/' });
        setCookie('userID', data.data.userID, { path: '/' });
        //@ts-ignore
        window.analytics.identify(data.data.userID);
      }
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to login: ${error.message}`);
      }
    },
  });
}
